var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonStyle,on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"x-large":_vm.size === 'large',"color":"amber lighten-4"}},[_vm._v("mdi-"+_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }